import PropTypes from "prop-types";
import React from "react";

import styles from "./SelectableGrid.module.scss";

import OptionBtn from "./OptionBtn";

const SelectableGrid = ({
  chartType,
  headerTitle,
  headerLimitText,
  headerDisabledText,
  options,
  selectedOptions,
  disabledOptions,
  onSelect,
  selectAll,
  toggleSelectAll,
  highlightToday,
  initialDateInvalid,
}) => {
  const getSelectAllText = () => {
    return selectedOptions.length === options.length
      ? "Deselect all"
      : "Select all";
  };

  const isDisabled = (option) => {
    return disabledOptions.includes(option.value);
  };

  const isSelected = (option) => {
    return selectedOptions.includes(option);
  };

  return (
    <div className="selectable-grid-wrapper">
      <div className={styles["header-container-" + chartType]}>
        <div className={styles["header-title"]}>{headerTitle}</div>
        <div className={styles["header-limit-text"]}>{headerLimitText}</div>
        {headerDisabledText && (
          <div className={styles["header-disable-text"]}>
            {headerDisabledText}
          </div>
        )}
        {
          initialDateInvalid && (
            <div className={styles["header-alert"]}>
              You previously selected an online restricted date or dates
            </div>
          )
        }
        {selectAll && (
          <div className={styles["header-select-all"]}>
            <button
              id={`select-all-${chartType}`}
              onClick={() => toggleSelectAll()}
            >
              {getSelectAllText() + " " + chartType + "s"}
            </button>
          </div>
        )}
        {selectAll && (
          <div className={styles["header-select-all-phone"]}>
            <button
              id={`select-all-${chartType}-mobile`}
              onClick={() => toggleSelectAll()}
            >
              {getSelectAllText()}
            </button>
          </div>
        )}
      </div>
      <div className={styles["options-container-" + chartType]}>
        {options &&
          options.map((option, i) => {
            return (
              <OptionBtn
                chartType={chartType}
                key={i}
                onClick={() => onSelect(option)}
                disabled={isDisabled(option)}
                option={option}
                selected={isSelected(option)}
                cls={(() => {
                  if (!highlightToday) {
                    return "";
                  }
                  if (chartType === 'day' && new Date().getDate() === option.value) {
                    return "today";
                  }

                  if (chartType === 'month' && new Date().getMonth() === option.value) {
                    return "today";
                  }
                })()}
              />
            );
          })}
      </div>
    </div>
  );
};

SelectableGrid.defaultProps = {
  selectedOptions: [],
  disabledOptions: [],
};

SelectableGrid.propTypes = {
  chartType: PropTypes.string,
  headerTitle: PropTypes.string,
  headerLimitText: PropTypes.string,
  headerDisabledText: PropTypes.string,
  onSelect: PropTypes.func,
  selectAll: PropTypes.bool,
  toggleSelectAll: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  selectedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  disabledOptions: PropTypes.arrayOf(PropTypes.number),
};

export default SelectableGrid;